import CardItemLoading from "@/components/loading/carItemLoading";
import { commissionOf } from "@/modules/peyment/useInvoiceStaff";
import { NoResult } from "@/components/noResult";
import PersianSupportNumberInput from "@/components/persianNumberInput";
import { MerchantServiceCategoryListData, MerchantUserListData, MerchantServiceDto, MerchantUserDto } from "@/models/club";
import { AddServiceDto } from "@/pages/dashboard/payment/add/mobileView";
import { Button, Card, Drawer, Group, InputBase, LoadingOverlay, Stack, Text } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconPercentage, IconSearch, IconX } from "@tabler/icons-react";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import ScheduleItem from "../team/list/scheduleItem";

// A chair renter keeps the whole price: the salon's commission does not apply to them (for now).
const isChairRenter = (member?: unknown) => Boolean((member as { isChairRenter?: boolean } | undefined)?.isChairRenter);


const schema = Yup.object().shape({
    percentage: Yup.string()
        // No commission is a valid choice: 0 to 100.
        .test(
            "between-zero-and-hundred",
            "درصد کمیسیون باید بین ۰ تا ۱۰۰ باشد",
            (value) => Number(value) >= 0 && Number(value) <= 100
        )
        .required("مقدار درصد را وارد نمایید"),
    price: Yup.string().required("مبلغ اجباری می باشد"),
});


type Props = {
    opened: boolean,
    onClose: () => void
    setServices: Dispatch<SetStateAction<AddServiceDto[]>>
    loading: boolean,
    allServices: MerchantServiceCategoryListData | undefined,
    teamMembers: MerchantUserListData | undefined
    // A stylist cannot change their own commission.
    commissionLocked?: boolean
}

function SelectService({ onClose, opened, setServices, allServices, teamMembers, loading, commissionLocked = false }: Props) {

    const [selectedProfession, setSelectedProfession] = useState<MerchantUserDto | null>(null);
    // const { data: user, isFetching } = useGetMerchantUserById(Number(selectedProfession?.id || 0));
    const [selectedService, setSelectedService] = useState<MerchantServiceDto | null>(null);
    const [openedPrice, { open: openPrice, close: closePrice }] = useDisclosure(false);
    const [openedProfession, { open: openProfession, close: closeProfession }] = useDisclosure(false);
    const [filter, setFilter] = useState("");
    // const services = (user as MerchantUserDto)?.merchantServices;


    const form = useForm<{
        price: number | undefined, percentage: number | undefined
    }>({
        initialValues: {
            price: undefined,
            percentage: undefined
        },
        validate: yupResolver(schema)
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submit = (values: any) => {
        setServices((e) => [...e, {
            percentage: values?.percentage || 0,
            service: selectedService || {},
            price: values?.price || 0,
            profession: selectedProfession || {},
            id: uuidv4(),
            isRemovable: false
        }])
        closePrice();
        onClose();
        closeProfession();
        form.reset();
        setSelectedProfession(null);
        setSelectedService(null);

    }

    useEffect(() => {
        form.setValues({
            price: selectedService?.startingPrice || undefined,
            percentage: commissionOf(selectedProfession)
        })
    }, [selectedService])


    return (
        <>
            <Drawer opened={opened} onClose={onClose} radius="md"
                position="bottom"
                size="lg">
                <LoadingOverlay />
                {/* <Stack gap="5" pb="md">
                    <Text fw="bold" size="lg">
                        انتخاب اعضا مجموعه
                    </Text>
                    <Text size="xs" c="dimmed">
                        برای نمایش  خدمات ابتدا اعضا مجموعه را انتخاب نمایید
                    </Text>
                </Stack> */}

                {/* <SelectProfession data={data || []} selectedItem={selectedProfession} setSelectedItem={setSelectedProfession} /> */}
                <Stack gap="xs" >
                    <Text>
                        انتخاب خدمت
                    </Text>
                    <InputBase
                        size="sm"
                        value={filter}
                        leftSection={<IconSearch size={15} />}
                        styles={{
                            label: {
                                fontSize: "0.8rem",
                            },
                            description: {
                                fontSize: "0.7rem",
                            },
                        }}

                        placeholder="جستجو..."
                        onChange={(e) => setFilter(e.target.value)}
                        rightSection={filter ? <IconX onClick={() => setFilter("")} /> : null}
                    />
                    {
                        loading ? <CardItemLoading count={3} /> :
                            allServices?.length === 0 ? <>
                                <Group justify="center" mt="md">
                                    <NoResult title="خدمتی تعریف نشده است" />
                                </Group>

                            </> :
                                <Stack gap="5" align="flex-start" px="xs" pt="md">
                                    {
                                        allServices?.map((category, index) => <Stack key={index}>
                                            <Text c="dimmed" size="sm">
                                                {category?.title}
                                            </Text>
                                            {
                                                category?.services?.filter(x => x.title?.includes(filter))?.map(x =>
                                                    <Card bg={selectedService?.id === x.id ? "var(--mantine-color-gray-2)" : ""} withBorder w="100%" onClick={() => { setSelectedService(x); openProfession() }}>
                                                        <Group styles={{
                                                            root: {
                                                                cursor: "pointer"
                                                            }
                                                        }} key={x.id} >
                                                            <Stack gap="xs" w="100%" >
                                                                <Group justify="space-between" w="100%">
                                                                    <Text>
                                                                        {x.title}
                                                                    </Text>
                                                                    <Text c="dimmed" size="xs">
                                                                        {x?.startingPrice?.toLocaleString()} ریال
                                                                    </Text>
                                                                </Group>
                                                                <Text c="dimmed" size="xs" lineClamp={1}>
                                                                    {x.description}
                                                                </Text>
                                                            </Stack>
                                                        </Group>
                                                    </Card>)
                                            }
                                        </Stack>
                                        )
                                    }
                                </Stack>
                    }
                </Stack>
            </Drawer>
            <Drawer opened={openedProfession} onClose={closeProfession} radius="md"
                position="bottom"
                size="md">
                <Stack gap="5" align="flex-start" px="sm" mt="md">
                    {(teamMembers?.some(x => x?.merchantServices?.some(x => x.id === selectedService?.id))
                        ? teamMembers.filter(x => x?.merchantServices?.some(x => x.id === selectedService?.id))
                        : teamMembers ?? []).map(team => <Group styles={{
                        root: {
                            cursor: "pointer",
                            borderRadius: "5px"
                        }
                    }} bg={selectedProfession?.id === team.id ? "var(--mantine-color-gray-2)" : ""} px="xs" w="100%" h={50}
                        onClick={() => {
                            setSelectedProfession(team);
                            form.setValues({
                                percentage: commissionOf(team)
                            });
                            openPrice();
                        }}>
                        <ScheduleItem team={team} size="sm" />
                    </Group>)}
                </Stack>
            </Drawer>
            <Drawer opened={openedPrice} onClose={closePrice} radius="md"
                position="bottom"
                size="md">
                <Stack>
                    <Stack gap="5">
                        <Text fw="bold" size="lg">
                            مبلغ و کمیسیون
                        </Text>
                        <Text size="xs" c="dimmed">
                            مبلغ سرویس و کمیسیون را وارد نمایید
                        </Text>
                    </Stack>

                    <form
                        onSubmit={form.onSubmit(submit)}
                        className="w-100"
                    >
                        <Stack pb="md">
                            <PersianSupportNumberInput
                                size="lg"
                                withThousandsSeparator
                                withAsterisk
                                value={form?.values?.price?.toString() || ""}
                                leftSection={<Text>ریال</Text>}
                                styles={{
                                    input: {
                                        direction: "ltr",
                                        textAlign: "left",
                                        paddingLeft: "1rem",
                                    },
                                    label: {
                                        fontSize: "1rem",
                                    },
                                    description: {
                                        fontSize: "0.8rem"
                                    }
                                }}
                                label="قیمت"
                                description="قیمت سرویس را وارد نمایید"
                                onChangeHandler={(e) =>
                                    form.setValues({
                                        price: e ? Number(e) : undefined,
                                    })
                                }
                                error={form?.errors?.price}

                            />
                            <PersianSupportNumberInput
                                rightSection={<IconPercentage size="15" />}
                                size="lg"
                                withAsterisk
                                value={form?.values?.percentage?.toString() || ""}
                                withThousandsSeparator

                                styles={{
                                    input: {
                                        direction: "ltr",
                                        textAlign: "left",
                                        paddingLeft: "2.5rem",

                                    },
                                    label: {
                                        fontSize: "1rem",
                                    },
                                    description: {
                                        fontSize: "0.8rem"
                                    }
                                }}
                                label={"درصد کمیسون"}
                                disabled={commissionLocked || isChairRenter(selectedProfession)}
                                description={isChairRenter(selectedProfession) ? "آرایشگر اجاره‌ای؛ کمیسیون ندارد" : undefined}
                                onChangeHandler={(e) =>
                                    form.setValues({
                                        percentage: e ? Number(e) : undefined,
                                    })
                                }
                                error={form?.errors?.percentage}
                            />

                            <Button fullWidth type="submit" size="lg">
                                ثبت
                            </Button>
                        </Stack>
                    </form>
                </Stack>
            </Drawer>

        </>
    )
}

export default SelectService